<div class="dialog-style-form">
    <mat-icon (click)="closeDialog()" [attr.aria-label]="'close dialog'">close</mat-icon>
    <div>
        <app-term-dialog-content [lmpmLink]="lmpmLink" [lmpmTermLink]="lmpmTermLink"></app-term-dialog-content>
    </div>
    <div class="agree-btn">
        <mat-checkbox class="example-margin" [checked]="agreeTermCheck" (change)="agreeTerm()"
            >I agree to&nbsp;Terms and Conditions
        </mat-checkbox>
    </div>
</div>
